/**
 * Store widgets: sales rows and done rows. The mini bars and the KPI strip's 12-month chart left with the
 * Bugün redesign (panel audit 25 Oct 2026); Satışlar keeps the full chart.
 */

import type { DoneItem, Sale } from '../api/types.js';
import { formatRelativeDay, formatUsd, wallParts } from '../lib/format.js';
import { Icon } from './icons.js';

export function SalesRow({ sale }: { sale: Sale }) {
  return (
    <div className="sale">
      <span className="sale__day mono">{wallParts(sale.at).day}</span>
      <span className="country mono">{sale.country}</span>
      <span className="sale__title">{sale.title}</span>
      <span className="sale__amount mono">{formatUsd(sale.amount)}</span>
    </div>
  );
}

export function DoneRow({ item, now, onRevert }: { item: DoneItem; now: number; onRevert: () => void }) {
  return (
    <div className="done-row">
      <span className="done-row__text">
        <span className="done-row__title">{item.title}</span>
        <span className="done-row__meta">
          {formatRelativeDay(item.at, now)}
          {' · '}
          {item.status === 'awaiting_send' ? (
            'Gönderilmeyi bekliyor'
          ) : item.status === 'failed' ? (
            <span className="danger">Uygulanamadı · {item.result}</span>
          ) : item.status === 'queued' ? (
            'Yürütücüde sırada · henüz uygulanmadı'
          ) : item.status === 'dry_run' ? (
            <span className="warning">Deneme modu · kaydedildi, uygulanmadı</span>
          ) : item.status === 'cancelled' ? (
            <span className="ink-2">Geri alındı · uygulanmadı</span>
          ) : (
            <>
              <Icon name="check" size={12} stroke={2.5} className="ok inline-icon" /> {item.result}
            </>
          )}
        </span>
      </span>
      {item.revertible ? (
        <button type="button" className="text-btn" onClick={onRevert}>
          Eski hâline dön
        </button>
      ) : null}
    </div>
  );
}
